export default __webpack_public_path__ + "static/media/profile_tip_subscription.e4910b7f.svg";